import React from "react";
import ReactImageGallery from "react-image-gallery";
import {css, Theme} from "@emotion/react";

import "react-image-gallery/styles/css/image-gallery.css";
interface IProps {
    src: any[] | boolean;
    aws?: string;
    order?: string[] | string;
}
const S3_BUCKET = "s3-zakupauto-service";
const REGION = "eu-central-1";

export const SliderComponent = (props: IProps) => {
    const wpImages = Array.isArray(props.src)
        ? props.src.map((img) => ({
              token: `wp:${img.id ?? img.ID}`,
              original: img.sizes?.large || img.url,
              thumbnail: img.sizes?.thumbnail || img.url
          }))
        : [];
    const s3Images = (props.aws || "")
        .split("|")
        .filter(Boolean)
        .map((key) => {
            const url = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${key}`;
            return {token: `s3:${key}`, original: url, thumbnail: url};
        });
    const order = Array.isArray(props.order) ? props.order : typeof props.order === "string" ? props.order.split("|").filter(Boolean) : [];
    const allImages = [...wpImages, ...s3Images];
    const byToken = new Map(allImages.map((image) => [image.token, image]));
    const orderedImages = order.map((token) => byToken.get(token)).filter((image): image is (typeof allImages)[number] => Boolean(image));
    const usedTokens = new Set(orderedImages.map((image) => image.token));
    const fallbackImages = props.aws ? s3Images : wpImages;
    const gallImg = (order.length > 0 ? [...orderedImages, ...allImages.filter((image) => !usedTokens.has(image.token))] : fallbackImages).map(
        ({original, thumbnail}) => ({original, thumbnail})
    );

    return (
        <div className="slider-container" css={sliderWrapper}>
            <ReactImageGallery items={gallImg} />
        </div>
    );
};

const sliderWrapper = (theme: Theme) => css`
    margin: 0 auto;
    width: 100%;
    border-color: white;

    .image-gallery-svg {
        color: ${theme.colors.brand_primary};
    }
    .image-gallery-thumbnail.active,
    .image-gallery-thumbnail:focus {
        border-color: ${theme.colors.brand_primary};
    }
`;
